import { FLAGS } from '@/config/feature-flags';
import { useGatedFlagAccess, type GatedFlagAccess } from './use-gated-flag-access';

export type HomePageAccess = GatedFlagAccess;

/**
 * Whether the new Home page at `/` is open to this user (NPJB-899). The route guard and the
 * header's Home item both read this, so they always agree.
 *
 * Fail-closed via the registry default (`false`): an unreachable Flagsmith sends `/` to the
 * Campaigns list, which is what `/` showed before Home existed.
 */
export const useHomePageAccess = (): HomePageAccess =>
  useGatedFlagAccess(FLAGS.homePage, '__FF_HOME_PAGE__');
